
import { Form, Button } from 'react-bootstrap';
import { TypeName } from './MemberComp';

const DropdownForm = ({ label, options, value, onChange, name }) => {
    return (
        <Form.Group className="mb-3">
            <Form.Label>{label}</Form.Label>
            <Form.Select
                name={name}
                value={value}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="-">Select {label.toLowerCase()}</option>
                {Object.entries(options).map(([key, display]) => (
                    <option key={key} value={key}>
                        {display}
                    </option>
                ))}
            </Form.Select>
        </Form.Group>
    );
};


const TextArrayForm = ({ label, values, onChange }) => {
    const handleChange = (index, value) => {
        const updated = [...values];
        updated[index] = value;
        onChange(updated);
    };

    const addField = () => {
        onChange([...(values || []), '']);
    };

    const removeField = (index) => {
        const updated = [...values];
        updated.splice(index, 1);
        onChange(updated);
    };

    return (
        <Form.Group className="mb-3">
            <Form.Label>{label}</Form.Label>

            {values?.map((value, index) => (
                <div key={index} className="d-flex mb-2">
                    <Form.Control
                        value={value}
                        onChange={(e) => handleChange(index, e.target.value)}
                        className="me-2"
                    />
                    <Button
                        variant="outline-danger"
                        onClick={() => removeField(index)}
                    >
                        ×
                    </Button>
                </div>
            ))}

            <Button variant="outline-primary" onClick={addField}>
                + Add {label?.toLowerCase() || 'item'}
            </Button>
        </Form.Group>
    );
};

export const MappingForm = props => {
    const { structure, data, setData } = props;

    return structure.map((struct) => {
        const { title, type, field } = struct;
        if (type === "text") return (
            <Form.Group className='mb-3' key={field}>
                <Form.Label>{title}</Form.Label>
                <Form.Control 
                    type={type}
                    value={data[field] ?? ""}
                    onChange={e => setData(d => ({...d, [field]: e.target.value}))}
                />
            </Form.Group>
        );
        if (type === "textarea") return (
            <Form.Group className='mb-3' key={field}>
                <Form.Label>{title}</Form.Label>
                <Form.Control 
                    as="textarea"
                    rows={3}
                    value={data[field] ?? ""}
                    onChange={e => setData(d => ({...d, [field]: e.target.value}))}
                />
            </Form.Group>
        );
        if (type === "file") return (
            <Form.Group className='mb-3' key={field}>
                <Form.Label>{title}</Form.Label>
                <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={e => setData(d => ({ ...d, [field]: e.target.files[0] || null }))}
                />
            </Form.Group>
        );
        if (type === "files") return (
            <Form.Group className='mb-3' key={field}>
                <Form.Label>{title}</Form.Label>
                <Form.Control
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={e => setData(d => ({ ...d, [field]: Array.from(e.target.files) || [] }))}
                />
            </Form.Group>
        );
        if (type === "switch") return (
            <Form.Check
                key={field}
                type={type}
                label={title}
                checked={data[field] ?? false}
                onChange={() => setData(d => ({ ...d, [field]: !d[field] }))}
                className="mb-2"
            />
        );
        if (type === "date") return (
            <Form.Group className='mb-3' key={field}>
                <Form.Label>{title}</Form.Label>
                <Form.Control
                    type="date"
                    value={data[field] ?? ""}
                    onChange={e => setData(d => ({ ...d, [field]: e.target.value }))}
                />
            </Form.Group>
        );
        if (type === "array-text") return (
            <Form.Group className="mb-3" key={field}>
                <Form.Label>{title}</Form.Label>
                <Button
                    variant="primary" size="sm" className='ms-2'
                    
                    onClick={() => {
                        const newArray = [...(data[field] ?? []), ""];
                        setData(d => ({ ...d, [field]: newArray }));
                    }}
                >Add</Button>
                {(data[field] ?? []).map((item, idx) => (
                    <div key={idx} className="d-flex mb-2 gap-2">
                        <Form.Control
                            type="text"
                            value={item}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = e.target.value;
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={() => {
                                const newArray = [...(data[field] ?? [])];
                                newArray.splice(idx, 1);
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        >Delete</Button>
                    </div>
                ))}
                
            </Form.Group>
        );
        if (type === "array-tuple") return (
            <Form.Group className="mb-3" key={field}>
                <Form.Label>{title}</Form.Label>
                <Button
                    variant="outline-primary" size="sm" className='ms-2'
                    onClick={() => {
                        const updated = [...(data[field] ?? []), ["", ""]];
                        setData(d => ({ ...d, [field]: updated }));
                    }}
                >Add {title}</Button>
                {(data[field] ?? []).map(([val1, val2], idx) => (
                    <div key={idx} className="d-flex mb-2 gap-2 align-items-center">
                        <Form.Control
                            type="text"
                            placeholder="First value"
                            value={val1 ?? ""}
                            onChange={e => {
                                const updated = [...(data[field] ?? [])];
                                updated[idx][0] = e.target.value;
                                setData(d => ({ ...d, [field]: updated }));
                            }}
                        />
                        <Form.Control
                            type="text"
                            placeholder="Second value"
                            value={val2 ?? ""}
                            onChange={e => {
                                const updated = [...(data[field] ?? [])];
                                updated[idx][1] = e.target.value;
                                setData(d => ({ ...d, [field]: updated }));
                            }}
                        />
                        <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => {
                                const updated = [...(data[field] ?? [])];
                                updated.splice(idx, 1);
                                setData(d => ({ ...d, [field]: updated }));
                            }}
                        >Delete</Button>
                    </div>
                ))}

            </Form.Group>
        );
        if (type === "timeline") return (
            <Form.Group className="mb-3" key={field}>
                <Form.Label>{title}</Form.Label>
                <Button
                    variant="outline-primary"
                    size="sm" className='ms-2'
                    onClick={() => {
                        const newArray = [...(data[field] ?? []), { years: "", txt: "" }];
                        setData(d => ({ ...d, [field]: newArray }));
                    }}
                >Add</Button>
                {(data[field] ?? []).map((item, idx) => (
                    <div key={idx} className="d-flex gap-2 mb-2">
                        <Form.Control
                            type="text"
                            placeholder="ex. 2023-2024, 2022;2024 or 2024-present"
                            value={item.years ?? ""}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = { ...newArray[idx], years: e.target.value };
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Form.Control
                            type="text"
                            placeholder="description"
                            value={item.txt ?? ""}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = { ...newArray[idx], txt: e.target.value };
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => {
                                const newArray = [...(data[field] ?? [])];
                                newArray.splice(idx, 1);
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        >Delete</Button>
                    </div>
                ))}
                
            </Form.Group>
        );

        if (type === "links") return (
            <Form.Group className="mb-3" key={field}>
                <Form.Label>{title}</Form.Label>
                <Button
                    variant="outline-primary"
                    size="sm" className='ms-2'
                    onClick={() => {
                        const newArray = [...(data[field] ?? []), { platform: "", url: "" }];
                        setData(d => ({ ...d, [field]: newArray }));
                    }}
                >Add</Button>
                {(data[field] ?? []).map((item, idx) => (
                    <div key={idx} className="d-flex gap-2 mb-2">
                        <Form.Control
                            type="text"
                            placeholder="Platform Name (Google Scholar, URCID, ...)"
                            value={item.platform ?? ""}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = { ...newArray[idx], platform: e.target.value };
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Form.Control
                            type="text"
                            placeholder="Paste link here"
                            value={item.url ?? ""}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = { ...newArray[idx], url: e.target.value };
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => {
                                const newArray = [...(data[field] ?? [])];
                                newArray.splice(idx, 1);
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        >Delete</Button>
                    </div>
                ))}
                
            </Form.Group>
        );

        if (type === "publications") return (
            <Form.Group className="mb-3" key={field}>
                <Form.Label>{title}</Form.Label>
                <Button
                    variant="outline-primary"
                    size="sm" className='ms-2'
                    onClick={() => {
                        const newArray = [...(data[field] ?? []), { txt: "", journal: "", url: "" }];
                        setData(d => ({ ...d, [field]: newArray }));
                    }}
                >Add</Button>
                {(data[field] ?? []).map((item, idx) => (
                    <div key={idx} className="d-flex gap-2 mb-2">
                        <Form.Control
                            type="text"
                            placeholder="reference"
                            value={item.txt ?? ""}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = { ...newArray[idx], txt: e.target.value };
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Form.Control
                            type="text"
                            placeholder="Journal name (to be highlighted, match with the reference)"
                            value={item.journal ?? ""}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = { ...newArray[idx], journal: e.target.value };
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Form.Control
                            type="text"
                            placeholder="Link (optional)"
                            value={item.url ?? ""}
                            onChange={e => {
                                const newArray = [...(data[field] ?? [])];
                                newArray[idx] = { ...newArray[idx], url: e.target.value };
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        />
                        <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => {
                                const newArray = [...(data[field] ?? [])];
                                newArray.splice(idx, 1);
                                setData(d => ({ ...d, [field]: newArray }));
                            }}
                        >Delete</Button>
                    </div>
                ))}
                
            </Form.Group>
        );

        if (type === "checkbox") return (
            <Form.Group className="mb-3" key={field}>
                <Form.Label>{title}</Form.Label>
                {(data[field] ? Object.keys(data[field]): []).map((item, idx) => (
                    <Form.Check 
                        key={idx}
                        type='checkbox'
                        label={item}
                        id={"checkbox-"+idx}
                        checked={data[field][item]}
                        onChange={() => setData(d => ({ ...d, [field]: {...d[field], [item]: !d[field][item]} }))}
                    />
                ))}
            </Form.Group>
            
        );

        if (type === "type") return (
            <Form.Group className="mb-3" key={field}>
                <Form.Label>{title}</Form.Label>
                <Form.Select
                    value={data[field]}
                    onChange={e => setData(d => ({ ...d, [field]: e.target.value || "" }))}
                >
                    <option value="">-</option>
                    {['0', '1', '2', '3', '4', '5'].map(key => (
                        <option value={key} key={key}>{TypeName[key]}</option>
                    ))}
                </Form.Select>
            </Form.Group>
        );


        return null;
    })
}



export { DropdownForm, TextArrayForm }
